import React from 'react';
import { useDispatch } from 'react-redux';

import { Box } from '@missionlabs/smartagent-app-components';

import Contact from 'views/Home/Contact';
import Controls from 'views/Home/Dialler/Controls';
import Incoming from 'views/Home/Dialler/Incoming';
import InCall from 'views/Home/Dialler/InCall';
import Monitoring from 'views/Home/Dialler/Monitoring';

import useCall from 'hooks/redux/useCall';
import useContact from 'hooks/redux/useContact';
import useMonitoring from 'hooks/redux/useMonitoring';

import { makeCall } from 'store/call/call.actions';

import './dialler.scss';

const Dialler: React.FC = () => {
    const dispatch = useDispatch();

    const contact = useContact();
    const { incoming = false, connections = [], direction, start, number } = useCall() ?? {};
    const { isMonitoringOrBarging, isEnhancedMonitoringEnabled } = useMonitoring();

    const isLiveMonitoring = isMonitoringOrBarging && isEnhancedMonitoringEnabled;

    return (
        <Box className="dialler">
            {connections.length === 0 ? (
                <Controls makeCall={(number, name, endpoint) => dispatch(makeCall(number, name, endpoint))} />
            ) : incoming ? (
                <Incoming />
            ) : isLiveMonitoring ? (
                <Monitoring name={number} callDirection={direction} start={start} />
            ) : (
                <InCall />
            )}
            {!!contact && <Contact contact={contact} />}
        </Box>
    );
};

export default Dialler;
